import { render, staticRenderFns } from "./Fussboden.vue?vue&type=template&id=04ace231"
import script from "./Fussboden.vue?vue&type=script&lang=js"
export * from "./Fussboden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports